import api from '@/api/axiosConfig.js';

const buildQuery = (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.fechaDesde) params.set('fecha_desde', filters.fechaDesde);
  if (filters.fechaHasta) params.set('fecha_hasta', filters.fechaHasta);
  if (filters.sucursalId) params.set('sucursal_id', filters.sucursalId);
  if (filters.clienteId) params.set('cliente_id', filters.clienteId);
  if (filters.page) params.set('page', filters.page);
  if (filters.pageSize) params.set('page_size', filters.pageSize);
  const query = params.toString();
  return query ? `?${query}` : '';
};

export const fetchReportesKpis = async (filters) => {
  const response = await api.get(`/api/reportes/kpis${buildQuery(filters)}`);
  return response.data?.data;
};

export const fetchReporteOperacion = async (filters) => {
  const response = await api.get(`/api/reportes/operacion${buildQuery(filters)}`);
  return response.data?.data;
};

export const fetchReporteFinanzas = async (filters) => {
  const response = await api.get(`/api/reportes/finanzas${buildQuery(filters)}`);
  return response.data?.data;
};

export const fetchReporteClientes = async (filters) => {
  const response = await api.get(`/api/reportes/clientes${buildQuery(filters)}`);
  return response.data?.data;
};

export const fetchReporteChoferes = async (filters) => {
  const response = await api.get(`/api/reportes/choferes${buildQuery(filters)}`);
  return response.data?.data;
};

export const fetchReporteGuiasPendientes = async (filters) => {
  const response = await api.get(`/api/reportes/guias-pendientes${buildQuery(filters)}`);
  return response.data?.data;
};

export const fetchReporteCobranzasOperativas = async (filters) => {
  const response = await api.get(`/api/reportes/cobranzas${buildQuery(filters)}`);
  return response.data?.data;
};

export const fetchReporteFacturacionOperativa = async (filters) => {
  const response = await api.get(`/api/reportes/facturacion${buildQuery(filters)}`);
  return response.data?.data;
};

export const fetchReporteRepartosOperativos = async (filters) => {
  const response = await api.get(`/api/reportes/repartos${buildQuery(filters)}`);
  return response.data?.data;
};

export const fetchReporteAlertasOperativas = async (filters) => {
  const response = await api.get(`/api/reportes/alertas${buildQuery(filters)}`);
  return response.data?.data;
};
